module.exports = __webpack_public_path__ + "prod/1.42.2/img/three-screen.74da512a.png";